import { UserOutlined, BookOutlined, HomeOutlined, PictureOutlined, HeartOutlined } from "@ant-design/icons";

export const sidebarItems = [
  {
    key: "/dashboard",
    icon: <HomeOutlined />,
    label: "Dashboard",
  },
  {
    key: "/dashboard/users",
    icon: <UserOutlined />,
    label: "Users",
  },
  {
    key: "/dashboard/recipes",
    icon: <BookOutlined />,
    label: "Recipes",
  },
  {
    key: "/dashboard/home-screen",
    icon: <PictureOutlined />,
    label: "Home Screen",
  },
  {
    key: "/dashboard/health-screen",
    icon: <HeartOutlined />,
    label: "Health Screen",
  },
];
